<template>
  <div v-loading="loading" class="portfoliofileupload">
    <div>
      <el-radio-group v-model="radioportfolio" size="mini">
        <el-radio-button label="new">{{ $t('portfoliosSelector.new-portfolio') }}</el-radio-button>
        <el-radio-button label="update">{{ $t('portfoliosSelector.update-portfolio') }}</el-radio-button>
        <!-- <el-radio-button label="continue">{{ $t('portfoliosSelector.continue-portfolio') }}</el-radio-button> -->
      </el-radio-group>
    </div>
    <div class="container-block-pf mt-2">
      <div v-if="radioportfolio === 'new'" class="title-input">
        <div>{{ $t("portfoliosSelector.portfolio-name") }}</div>
        <el-input v-model="portfolioname" size="mini" type="text" class="infotxt pf-new-input" placeholder="enter portfolio name" />
      </div>
      <div v-else-if="radioportfolio === 'update'" class="title-input">
        <div>{{ $t("portfoliosSelector.portfolio-name") }}</div>
        <el-select v-model="selectedportfolioid" class="pf-up-select" filterable allow-create default-first-option :placeholder="$t('select-or-create-portfolio') + '*'">
          <el-option v-for="item in userportfolios" :key="item.id" :label="item.portfolioName" :value="item.id" />
        </el-select>
      </div>
    </div>
    <div v-if="radioportfolio !== 'continue'" class="container-block-pf mt-1">
      <div class="title-input">
        <div>{{ $t("portfoliosSelector.file") }}</div>
        <fileInput v-model="file" :accept="acceptfiles" />
      </div>
    </div>
    <div class="upd-portfolio-rules-container">
      <ul>
        <li>{{ $t('portfoliosSelector.upload-rule1') }}</li>
        <li>{{ $t('portfoliosSelector.upload-rule2') }}</li>
        <li>{{ $t('portfoliosSelector.upload-rule3') }}</li>
        <li>{{ $t('portfoliosSelector.upload-rule4') }}</li>
        <li>{{ $t('portfoliosSelector.upload-rule5') }}</li>
        <li>{{ $t('portfoliosSelector.upload-rule6') }}</li>
      </ul>
    </div>
    <div class="mt-2">
      <button class="brains-type1-btn" @click="submitFile()">{{ $t("portfoliosSelector.submit") }}</button>
    </div>
    <modal v-model="showdeleteconfirm" class="upd-portfolio-modal">
      <div class="upd-portfolio-content">{{ $t('portfoliosSelector.warning-existing-portfolio') }}</div>
      <div class="upd-portfolio-btncontrol">
        <button class="brains-type1-btn" @click="continuesubmit()">{{ $t('userData.accept') }}</button>
        <button class="brains-type3-btn propperpadding" @click="showdeleteconfirm = false">{{ $t('userData.cancel') }}</button>
      </div>
    </modal>
  </div>
</template>
<script>
import fileInput from '@/components/designComponents/fileInput'
import modal from '@/components/designComponents/modal'
import { mapState } from 'vuex'
export default {
  name: 'Portfoliofilec',
  components: {
    fileInput, modal
  },
  data() {
    return {
      radioportfolio: 'new',
      acceptfiles: '.xlsx',
      file: '',
      portfolioname: '',
      selectedportfolioid: '',
      selectedportfolioidContinue: '',
      testInputSelect: '',
      loading: false,
      showdeleteconfirm: false
    }
  },
  computed: {
    ...mapState('portfolio', {
      userportfolios: (state) => state.userportfolios
    }),
    userportfoliosUpdate() {
      return this.userportfolios.filter((item) => { return item.status !== 'Uploaded' })
    },
    userportfoliosContinue() {
      return this.userportfolios.filter((item) => { return item.status === 'Uploaded' })
    }
  },
  methods: {
    submitFile() {
      const vm = this
      // validacion
      if (this.file === '' || this.file === null || this.file === undefined) {
        this.$message({
          showClose: true,
          message: this.$t('portfoliosSelector.select-file-please'),
          type: 'error'
        })
        return
      }

      if (vm.radioportfolio === 'new') {
        // vm.portfolioname = vm.selectedportfolioid
        vm.selectedportfolioid = 0
        // validate not exist name
        const existingport = vm.userportfolios.filter((item) => { return item.portfolioName === vm.portfolioname })
        if (existingport.length > 0) {
          vm.$message({
            showClose: true,
            message: this.$t('portfoliosSelector.existing-portfolio-name'),
            type: 'error'
          })
          return
        }
      } else {
        vm.portfolioname = vm.userportfolios.filter((item) => {
          return item.id === vm.selectedportfolioid
        })[0].portfolioName
      }

      if (vm.portfolioname.trim() === '') {
        this.$message({
          showClose: true,
          message: this.$t('portfoliosSelector.enter-portfolio-name'),
          type: 'error'
        })
        return
      }
      if (vm.selectedportfolioid === 0) {
        vm.continuesubmit()
      } else {
        vm.showdeleteconfirm = true
      }
    },
    continuesubmit() {
      const vm = this
      vm.showdeleteconfirm = false
      const formData = new FormData()
      formData.append('FileToUpload', this.file)
      formData.append('Name', this.portfolioname)
      formData.append('Id', this.selectedportfolioid)

      vm.loading = true
      vm.$store.dispatch('portfolio/uploaduserportfolio', formData).then((response) => {
        console.log(response)
        if (response.error) {
          if (response.msg === 'rowcolempty') {
            this.$message({
              showClose: true,
              message: this.$t('portfoliosSelector.upload-rule3'),
              type: 'error'
            })
          } else {
            vm.$alert(vm.$t(response.msg), 'Warning', {
              confirmButtonText: 'OK'
            })
          }
        } else {
          // vm.userportfolios.push({ id: 0, portfolioName: vm.portfolioname })
          this.$message({
            showClose: true,
            message: this.$t('portfolio-jobstarted'),
            type: 'success'
          })
        }
        vm.loading = false
      }).catch((error1) => {
        console.error(error1)
        this.$message({
          showClose: true,
          message: this.$t('portfoliosSelector.invalid-portfolio-file'),
          type: 'error'
        })
        vm.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.upd-portfolio-rules-container {
  background-color: #1e3cff9a;
  height: 100%;
  margin: 10px 5px 0 5px;

  ul {
    list-style-type: circle;
    font-size: 13px;
    padding: 5px 5px 5px 20px;
    text-align: left;

    li {
      line-height: 20px;
      font-family: 'Montserrat-SemiBold',sans-serif;
    }
  }
}

.propperpadding {
  padding: 7px 20px 7px 20px;
}

.upd-portfolio-btncontrol {
  gap: 20px;
  display: flex;
  position: absolute;
  bottom: 20px;
  width: 100%;
  align-items: center;
  justify-content: right;
  padding-right: 50px;
}

.upd-portfolio-content {
  padding: 40px 30px 0 30px;
  width: 100%;
  height: 100%;
  white-space: break-spaces;
  font-family: 'Montserrat-Regular',sans-serif;
  line-height: 20px;
}

.upd-portfolio-title {
  text-align: center;
  margin: 10px auto;
  padding: 5px;
  width: 80%;
  font-family: 'Montserrat-SemiBold',sans-serif;
  border-bottom: 2px solid #e5af44;
}

.upd-portfolio-content2 {
  padding: 0 25px;
  width: 100%;
  height: 100%;
  white-space: break-spaces;
  font-family: 'Montserrat-Regular',sans-serif;
  font-size: 14px;
  line-height: 20px;
}

.portfoliofileupload {
  width: 100%;
  padding: 20px 0;
  border: 1px solid #e5af44;
  display: flex;
  justify-content: center;
  text-align: center;
  white-space: nowrap;
  flex-direction: column;

  .title-input {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    width: 100%;

    & > div {
      font-family: 'Montserrat-SemiBold',sans-serif;
    }
  }

  .container-block-pf {
    display: flex;
    width: 70%;
    justify-content: flex-start;
    margin: 0 auto;
  }
}

</style>
<style>
.upd-portfolio-modal > .brains-asset-data-modal--content {
  width: 600px !important;
  height: 150px !important;
  min-height: 150px !important;
}
.upd-portfolio-modal2 > .brains-asset-data-modal--content {
  width: 600px !important;
  height: 150px !important;
  min-height: 150px !important;
}
.pf-up-select {
  width: 100%;
}
.pf-new-input .el-input__inner {
  height: 32px;
}
</style>
